<template>
  <div id="CpSpring">
    <div class="CpSpring-list">
      <swiper
        :slides-per-view="4.5"
        :space-between="80"
        :pagination="false"
        :breakpoints="breakpoints"
        :modules="modules"
      >
        <swiper-slide>
          <a
            href="#jikiba5a"
            v-smooth-scroll="{
              duration: 500,
              offset: -100,
              updateHistory: false,
            }"
          >
            <img src="images/banner/24sf_02.png" />
          </a>
        </swiper-slide>
        <swiper-slide>
          <a
            href="#jikiba5b"
            v-smooth-scroll="{
              duration: 500,
              offset: -100,
              updateHistory: false,
            }"
          >
            <img src="images/banner/24sf_03.png" />
          </a>
        </swiper-slide>
        <swiper-slide>
          <a
            href="#jikiba5c"
            v-smooth-scroll="{
              duration: 500,
              offset: -100,
              updateHistory: false,
            }"
          >
            <img src="images/banner/24sf_04.png" />
          </a>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper";
export default {
  data() {
    return {};
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {
      modules: [Pagination],
      breakpoints: {
        320: {
          slidesPerView: 1.25,
          spaceBetween: 20,
        },
        640: {
          slidesPerView: 1.5,
          spaceBetween: 20,
        },
        960: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
        1280: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
        1560: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
      },
    };
  },
};
</script>

<style lang="scss" scoped>
#CpSpring {
  width: 100%;
  height: 100%;
  padding: 0;
  overflow: visible;
  margin-bottom: calc($v-gap/2);
  h2 {
    font-weight: bold;
    font-size: 3rem;
    margin-bottom: 1em;
    span {
      margin-left: 1em;
      font-size: 1rem;
    }
  }
}
.CpSpring-list {
  padding: 0;
  @include tb {
    grid-template-columns: repeat(3, 1fr);
  }
  @include sp {
    grid-template-columns: repeat(2, 1fr);
  }
  .swiper {
    overflow: visible;
  }
}
</style>
